import { User } from "../Provider/LocalStorageProvider";
import { CommonService } from "../services/Common/CommonService";

export const getCountriesData = (
  setUser: React.Dispatch<React.SetStateAction<User>>
) => {
  CommonService.populateCountriesDetails()
    .then((res) => {
      if (res?.data?.data) {
        setUser((previousUser) => ({
          ...previousUser,
          countries: res.data.data,
        }));
      } else {
        setUser((previousUser) => ({
          ...previousUser,
          countries: [],
        }));
      }
      return [];
    })
    .catch((error) => {
      console.log(error);
      setUser((previousUser) => ({
        ...previousUser,
        countries: [],
      }));
    });
};
